import { loggedIn } from '../store';
export default {
  async get(url) {
    const res = await fetch(url, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
      },
    });
    if(res.status == 401){
      loggedIn.set(false);
    }
    return res;
  },

  async post(url, json) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(json)
    });
    if(res.status == 401){
      loggedIn.set(false);
    }
    return res;
  },

  async put(url, json = '') {
    const res = await fetch(url, {
      method: 'PUT',
      headers: { 
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(json)
    });
    if(res.status == 401){
      loggedIn.set(false);
    }
    return res;
  },

  async delete(url, json) {
    const res = await fetch(url, {
      method: 'delete',
      headers: { 
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(json)
    });
    if(res.status == 401){
      loggedIn.set(false);
    }
    return res;
  },

  async submit(url, form) {
    const res = await fetch(url, {
      method: 'POST',
      body: form
    });
    if(res.status == 401){
      loggedIn.set(false);
    }
    
    const data = await res.text();
    return data;
  },

  async hasTokenExpired(){
    const res = await fetch(`/auth/exp`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
      },
    });
    var expiryTime = await res.text();
           
    if(expiryTime < (Date.now() / 1000)){
      loggedIn.set(false);
      return true;
    }else{
      return false
    }
  },
  
}